import * as z from "zod";
import { TFunction } from "i18next";

export const createContactFormSchema = (t: TFunction) =>
  z.object({
    name: z.string().min(1, t("validation.required", "This field is required")),
    email: z
      .string()
      .min(1, t("validation.required", "This field is required"))
      .email(t("validation.emailInvalid", "Invalid email address")),
    subject: z.string().optional(),
    message: z
      .string()
      .min(1, t("validation.required", "This field is required")),
    nickname: z.string().optional(), // Honeypot
    formLoadTimestamp: z.number().optional(), // Timing guard (camelCase)
  });

export type ContactFormData = z.infer<
  ReturnType<typeof createContactFormSchema>
>;
